import { render } from "./index.vue?vue&type=template&id=60f30c32&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=60f30c32&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f30c32"]])

export default __exports__